import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import { Endpoints } from 'UI/constants/endpoints';
import { getId, nestTernary } from 'UI/utils';
import { OptionRenderers } from 'UI/utils/renderers';

import FPButtonMenu from '../FPButtonMenu';
import Searchbar from '../Searchbar';

import { useStyles } from './styles';

const BUTTONS_MAP = {
  action: FPActionButton,
  menu: FPButtonMenu
};

/**
 * @typedef BulkHeaderButtonDefinitions
 * @property {'action'|'menu'} type
 * @property {FPActionButtonProps|FPMenuButtonProps} props
 */

/**
 * @param {Object} props
 * @param {Array<BulkHeaderButtonDefinitions>} [props.buttonsDefinitions]
 * @param {Array<MenuButtonItemsProps>} [props.menuItems]
 * @param {Function} [props.onChange]
 * @param {Function} [props.onSelect]
 * @param {string} props.searchbarPlaceHolder
 * @param {string} props.title
 */
const BulkEmailContentHeader = ({
  buttonsDefinitions = null,
  onChange = null,
  onSelect = null,
  searchbarPlaceHolder,
  title
}) => {
  const classes = useStyles();
  const [search, setSearch] = useState({});
  const shouldMapButtons = buttonsDefinitions && Array.isArray(buttonsDefinitions);

  const searchData = () => onChange && onChange({ ...search, pagination: 1 });

  const handleChange = (name, value) => setSearch({ [name]: value });
  const handleSearch = () => search?.keyword && searchData();
  const handleSearchAsync = () => searchData();

  const onSelectHandler = (name, value) => {
    if (value) onSelect({ id: value.id, entity: value.entity });
    onSelect({ id: null, entity: null }); // autocomplete clear
  };

  return (
    <Grid container alignItems="center" className={classes.contentHeader}>
      <Grid item className={classes.searchContainer}>
        {nestTernary(
          !!onSelect,
          <AutocompleteSelect
            placeholder={searchbarPlaceHolder}
            url={Endpoints.BulkEmailsTemplatesSearch}
            apiVersion={2}
            displayKey="name"
            typeahead
            typeaheadLimit={null}
            onSelect={onSelectHandler}
            renderOption={OptionRenderers.templatesSearch('name')}
            noMargin
          />,
          <Searchbar
            name="keyword"
            value={search.keyword || ''}
            placeholder={searchbarPlaceHolder}
            width="auto"
            onChange={handleChange}
            onSearch={handleSearch}
            onSearchAsync={handleSearchAsync}
          />
        )}
      </Grid>
      <span className={classes.divider} />
      <Grid
        item
        container
        alignItems="center"
        justify="space-between"
        className={classes.titleContainer}
      >
        <Grid item className={classes.title}>
          <Tooltip title={title} aria-label={title} placement="top-start">
            <span aria-label={title}>{title}</span>
          </Tooltip>
        </Grid>
        <Grid item>
          {shouldMapButtons &&
            buttonsDefinitions.map((button, index) => {
              const ButtonComponent = BUTTONS_MAP[button.type];
              const buttonClassName = buttonsDefinitions[index + 1]
                ? classes.buttonRightMargin
                : '';
              return (
                <ButtonComponent key={getId()} className={buttonClassName} {...button.props} />
              );
            })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BulkEmailContentHeader;
